/* eslint-disable no-unused-vars */
import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import * as XLSX from "xlsx";
import {
	Tab,
	Tabs,
	Typography,
	Autocomplete,
	Checkbox,
	TextField,
	Button,
	IconButton,
	Divider,
	Alert,
	Tooltip,
	Box,
	Card,
	CircularProgress,
	Link,
	Modal,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
	List,
	ListItem,
	FormControlLabel,
	FormGroup,
	Paper,
} from "@mui/material";
import LinearProgress from '@mui/material/LinearProgress';
import ListSubheader from "@mui/material/ListSubheader";

import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import EditIcon from "@mui/icons-material/Edit";
import "./Admin.css";
import PageTitle from "../../components/PageTitle/PageTitle";
import customHttp from "../../services/customHTTP";
import Datagrid from "../../components/Datagrid/Datagrid";
import Settings from "../Settings/Settings";
import EditUserForm from "../../components/EditUserForm/EditUserForm";
import NewUserForm from "../../components/NewUserForm/NewUserForm";
import Swal from "sweetalert2";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import ManageDocuments from "../ManageDocuments/ManageDocuments";
import { useSite } from "../../context/siteContext";
import ManageSites from "../ManageSites/ManageSites";
import { useAuth } from "../../context/authContext";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ManageSiteMachines from "../../components/ManageSiteMachines/ManageSiteMachines";
import { DataGrid } from "@mui/x-data-grid";
import { AddCircle, Delete } from "@mui/icons-material";
import ManageCronJobs from "../../components/ManageCronJobs/ManageCronJobs";
import ManageCustomersMaster from "../../components/ManageCustomersMaster/ManageCustomersMaster";
import ManageSitesMaster from "../../components/ManageSitesMaster/ManageSitesMaster";
import ManageProductsMaster from "../../components/ManageProductsMaster/ManageProductsMaster";
import ManageMachinesMaster from "../../components/ManageMachinesMaster/ManageMachinesMaster";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import CloseIcon from '@mui/icons-material/Close';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import MenuIcon from "@mui/icons-material/Menu";
import InsightsIcon from "@mui/icons-material/Insights";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import MapIcon from "@mui/icons-material/Map";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import SourceIcon from "@mui/icons-material/Source";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import MoreTimeIcon from "@mui/icons-material/MoreTime";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import StoreIcon from "@mui/icons-material/Store";
import ArticleIcon from "@mui/icons-material/Article";
import ContrastIcon from "@mui/icons-material/Contrast";
import DefaultValues from "../../components/DefaultValues/DefaultValues";
import ManageChangeParts from "../../components/ManageChangeParts/ManageChangeParts";
import ModelUpload from "../../components/ModelUpload/ModelUpload";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import dayjs from "dayjs";
// import Geographic from "../Dashboard/Geographic";
// import Statistics from "../Dashboard/Statistics";
// import SalesAnalytics from "../Dashboard/SalesAnalytics";

const expectedHeaders = [
	"CustomerNumber",
	"CustomerName",
	"SiteNumber",
	"SiteName",
	"MachineNumber",
	"MachineName",
	"MachineSerialNo",
];

const navItems = [
	// {
	// 	header: "Dashboard",
	// 	items: [
	// 		{ text: "Sales Analytics", icon: <InsightsIcon />, view: "Admin" },
	// 		{ text: "Statistics", icon: <LeaderboardIcon />, view: "Admin" },
	// 		{ text: "Geographic", icon: <MapIcon />, view: "Admin" },
	// 	],
	// },
	{
		header: "Manage",
		items: [
			{ text: "Users", icon: <PeopleAltIcon />, view: "Admin" },
			{ text: "Sites", icon: <LocalLibraryIcon />, view: "Admin" },
			{ text: "Documents", icon: <SourceIcon />, view: "Admin" },
			{ text: "Machine Provision", icon: <PrecisionManufacturingIcon />, view: "Admin" },
			{ text: "Upload Models", icon: <FileUploadIcon />, view: "Admin" },
			{ text: "Change Parts", icon: <Inventory2Icon />, view: "Admin" },
		],
	},
	{
		header: "Administrator",
		items: [
			{ text: "All Products", icon: <Inventory2Icon />, view: "SuperAdmin" },
			{ text: "All Customers", icon: <SupervisorAccountIcon />, view: "SuperAdmin" },
			{ text: "All Sites", icon: <LocalLibraryIcon />, view: "SuperAdmin" },
			{ text: "All Machines", icon: <PrecisionManufacturingIcon />, view: "SuperAdmin" },
			{ text: "Scheduler", icon: <MoreTimeIcon />, view: "SuperAdmin" },
		],
	},
	{
		header: "Defaults",
		items: [{ text: "App Defaults", icon: <ArticleIcon />, view: "Admin" }],
	},
	{
		header: "Settings",
		items: [
			{ text: "Company Information", icon: <StoreIcon />, view: "SuperAdmin" },
			{ text: "Theme", icon: <ContrastIcon />, view: "SuperAdmin" },
		],
	},
];

function Admin() {
	const [activeIndex, setActiveIndex] = useState("Users");

	const [loading, setLoading] = useState(true);
	const [error, setError] = useState("");
	const [allUsers, setAllUsers] = useState([]);
	const [allCustomers, setAllCustomers] = useState([]);
	const [allSites, setAllSites] = useState([]);
	const [assignedSitesLoc, setAssignedSitesLoc] = useState([]);
	const [selectedUser, setSelectedUser] = useState(null); // State for selected user
	const [newUser, setNewUser] = useState({
		user_first_name: "",
		user_last_name: "",
		user_email: "",
		user_phone: "",
		user_role: "",
		user_status: "0", // Default status to "Pending"
	});
	const [createNewUser, setCreateNewUser] = useState(false);
	const [selectedUsersRows, setSelectedUsersRows] = useState([]);
	const [allUsersKey, setAllUsersKey] = useState(Date.now());
	const { selectedSite, siteData } = useSite();
	const [tableData, setTableData] = useState([]);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [selectedFile, setSelectedFile] = useState(null);
	const [submittingProvision, setSubmittingProvision] = useState(false);
	const [allMachines, setAllMachines] = useState([]);
	const [machineSelected, setMachineSelected] = useState(null);
	const [newModel, setNewModel] = useState(false);
	const [files, setFiles] = useState([]);
	const [isDragging, setIsDragging] = useState(false);
	const [uploadComplete, setUploadComplete] = useState(false);
	const fileInputRef = useRef(null);
	const [isChangePart, setIsChangePart] = useState(false);
	const { user } = useAuth();
	const [currentUser, setCurrentUser] = useState(user);
	// Handle tab changes

	useEffect(() => {
		const fetchData = async (endpoint, setState) => {
			try {
				const response = await customHttp.get(endpoint);
				if (response.data.data.length > 0) {
					setState(response.data.data);
				} else {
					setError(`Failed to fetch data: No data found for ${endpoint}.`);
				}
			} catch (err) {
				setError(`Failed to fetch data from ${endpoint}: ${err.message}`);
			} finally {
				setLoading(false);
			}
		};

		if (currentUser && currentUser.user_role === "Admin") {
			setLoading(true);
			fetchData("/users", setAllUsers);
			fetchData("/cus_sites/getcustomers", setAllCustomers);
			fetchData("/cus_sites/getsites", setAllSites);
		} else {
			setLoading(false);
		}
	}, [currentUser]);

	const fetchMachines = async () => {
		try {
			const response = await customHttp.get("/machines/models");
			if (response.data.success) {
				const machines = response.data.data;
				console.log("Models: ", machines);
				setAllMachines(machines);
			} else {
				setError("Failed to fetch data: No success flag.");
			}
		} catch (err) {
			setError("Failed to fetch data: " + err.message);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchMachines();
	}, []);

	useEffect(() => {
		refreshAllUsersKey();
	}, [allUsers]);

	const refreshAllUsersKey = () => setAllUsersKey(Date.now());

	const handleRowSelect = (rows) => {
		setSelectedUsersRows(rows);
	};

	const handleSendPasswordLink = (user_id) => {
		const sendPasswordEmail = async () => {
			try {
				const req_body = {
					userId: user_id,
				};
				const response = await customHttp.post("/users/passwordresetlink", req_body);

				if (response.data.data.length > 0) {
					Swal.fire({
						icon: "success",
						title: "Sent",
						text: "Password reset link sent successfully.",
					});
				} else {
					setError(`Failed to Delete users`);
					Swal.fire({
						icon: "error",
						title: "Error",
						text: "Failed to sent password reset link. Please try again.",
					});
				}
			} catch (err) {
				Swal.fire({
					icon: "error",
					title: "Error",
					text: `Failed to sent password reset link: ${err.message}`,
				});
			}
		};

		sendPasswordEmail();
	};

	const handleDeleteRows = () => {
		// Check if any rows are selected
		if (selectedUsersRows.length === 0) {
			// Show alert if no users are selected
			Swal.fire({
				icon: "warning",
				title: "No Users Selected",
				text: "Please select users to delete.",
			});
			return;
		}

		if (selectedUser) {
			setSelectedUser(null);
		}

		// Confirm deletion if users are selected
		Swal.fire({
			title: "Are you sure?",
			text: "You are about to delete selected users. This action cannot be undone!",
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#d33",
			cancelButtonColor: "#3085d6",
			confirmButtonText: "Yes, delete them!",
		}).then((result) => {
			if (result.isConfirmed) {
				// User confirmed, proceed with deletion
				const DeleteUserRows = async () => {
					try {
						const req_body = {
							userIds: selectedUsersRows,
						};
						const response = await customHttp.post("/users/delete", req_body);

						if (response.data.data.length > 0) {
							setAllUsers(response.data.data);
							Swal.fire({
								icon: "success",
								title: "Users Deleted",
								text: "Selected users have been deleted successfully.",
							});
						} else {
							setError(`Failed to Delete users`);
							Swal.fire({
								icon: "error",
								title: "Error",
								text: "Failed to delete users. Please try again.",
							});
						}
					} catch (err) {
						setError(`Failed to Delete users from: ${err.message}`);
						Swal.fire({
							icon: "error",
							title: "Error",
							text: `Failed to delete users: ${err.message}`,
						});
					} finally {
						setLoading(false);
					}
				};

				// Ensure user has Admin role before proceeding
				if (currentUser && currentUser.user_role === "Admin") {
					setLoading(true);
					DeleteUserRows();
				}
			}
		});
	};

	const formatDate = (dateString) => {
		const date = new Date(dateString);
		const month = `0${date.getMonth() + 1}`.slice(-2); // Get month (01-12)
		const day = `0${date.getDate()}`.slice(-2); // Get day (01-31)
		const year = date.getFullYear(); // Get full year
		const hours = `0${date.getHours()}`.slice(-2); // Get hours (00-23)
		const minutes = `0${date.getMinutes()}`.slice(-2); // Get minutes (00-59)

		return `${year}-${month}-${day} ${hours}:${minutes}`; // Return formatted date
	};

	// Define columns based on the `allUsers` data
	const columns = [
		{ field: "user_display_name", headerName: "Name", width: 200 },
		{
			field: "user_email",
			headerName: "Email",
			flex: 3,
			renderCell: (params) => {
				const statusText =
					params.row.user_status === 0
						? `${params.row.user_email} <span style="font-size: 10px; color: #aaa"> - Pending Approval</span>`
						: params.row.user_email;
				return <span dangerouslySetInnerHTML={{ __html: statusText }} />;
			},
		},
		{ field: "user_role", headerName: "Role" },
		{
			field: "user_status",
			headerName: "Status",
			valueFormatter: (value) => {
				// Check if user_status is 0, display "Pending", otherwise "Approved"
				return value === 0 ? "Pending" : "Approved";
			},
		},
		{
			field: "created",
			headerName: "Created Date",
			width: 180,
			valueFormatter: (value) => formatDate(value), // Use formatDate here
		},
		{
			field: "updated",
			headerName: "Updated Date",
			width: 180,
			valueFormatter: (value) => formatDate(value), // Use formatDate here
		},
		{
			headerName: "Actions",
			sortable: false,
			width: 100, // Ensure there's enough space for icons
			headerAlign: "center",
			align: "left",
			renderCell: (params) => (
				<div>
					<Tooltip title="Edit User">
						<IconButton
							color="primary"
							aria-label="Edit User"
							onClick={(event) => {
								event.stopPropagation();
								// Check if selectedUser is set, and reset it if necessary
								if (selectedUser) {
									setSelectedUser(null); // Reset selectedUser to null
								}
								handleEdit(params.row);
							}}>
							<EditIcon />
						</IconButton>
					</Tooltip>
					{params.row.user_password === "" && (
						<Tooltip title="Send Password Reset Link">
							<IconButton
								color="primary"
								aria-label="Edit User"
								onClick={(event) => {
									event.stopPropagation();

									handleSendPasswordLink(params.row.user_id);
								}}>
								<VpnKeyIcon />
							</IconButton>
						</Tooltip>
					)}
				</div>
			),
		},
	];

	const customButtons = [
		{
			label: "Create User",
			icon: <AddCircle />,
			onClick: () => {
				setAssignedSitesLoc([]);
				setSelectedUser(null);
				setCreateNewUser(true);
			},
		},
		{
			label: "Delete Selected",
			icon: <Delete />,
			onClick: () => {
				handleDeleteRows();
			},
		},
	];

	const uploadModelColumns = [
		{ field: "machine_number", headerName: "Machine Number", width: 200, align: "center", headerAlign: "center" },
		{ field: "machine_name", headerName: "Machine Name", flex: 1 },
		{
			field: "base_file_count",
			headerName: "# Machine Model File(s)",
			width: 300,
			align: "center",
			headerAlign: "center",
			renderCell: (params) => {
				const { row } = params;
				const fileCount = row.base_file_count || 0;
				const lastUpdated = params.value ? dayjs(params.value).format("MM-DD-YYYY HH:mm") : null;

				return fileCount > 0 ? (
					<div style={{ textAlign: "center" }}>
						<div>
							<b>
								{fileCount} Model{fileCount > 1 ? "s" : ""}
							</b>
						</div>
					</div>
				) : (
					<span style={{ fontSize: "10px", color: "gray" }}>N/A</span>
				);
			},
		},
		{
			field: "machine_last_updated",
			headerName: "Machine Model(s) Last Update",
			width: 300,
			align: "center",
			headerAlign: "center",
			renderCell: (params) => {
				const { row } = params;
				const fileCount = row.base_file_count || 0;
				const lastUpdated = params.value ? dayjs(params.value).format("MM-DD-YYYY HH:mm") : null;

				return fileCount > 0 ? (
					<div style={{ textAlign: "center" }}>
						<div>Last Update: {lastUpdated}</div>
					</div>
				) : (
					<span style={{ fontSize: "10px", color: "gray" }}>N/A</span>
				);
			},
		},
		{
			field: "cp_last_updated",
			headerName: "Change Part Model Last Update",
			width: 300,
			align: "center",
			headerAlign: "center",
			renderCell: (params) => {
				return params.value ? (
					`Last Update: ${params.value}`
				) : (
					<span style={{ fontSize: "10px", color: "gray" }}>N/A</span>
				);
			},
		},
	];

	const uploadModelButtons = [
		{
			label: "Add New Model",
			icon: <AddCircle />,
			onClick: () => {
				setNewModel(true);
			},
		},
	];

	const handleCloseModal = () => {
		setNewModel(false);
		setFiles([]);
		setIsChangePart(false);
		setUploadComplete(false);
	};

	// Define edit and delete handlers
	const handleEdit = (row) => {
		const customers =
			row.user_customers && row.user_customers.length > 0 ? row.user_customers.split(",").map(Number) : [];
		const userSites = row.user_sites && row.user_sites.length > 0 ? row.user_sites.split(",").map(Number) : [];

		const result = customers.map((cusId) => {
			// For each customer, filter the AllSites based on cus_id and user_sites
			const customerSites = allSites.filter((site) => site.cus_id === cusId && userSites.includes(site.site_id));

			return {
				customer: cusId,
				sites: customerSites.map((site) => site.site_id), // Only include the site_id in the array
			};
		});

		setAssignedSitesLoc(result);
		setSelectedUser(row);
		setCreateNewUser(false);
	};

	const handleFileChange = (event) => {
		setTableData([]);
		setIsModalOpen(false);
		const file = event.target.files[0];
		setSelectedFile(file);

		if (file) {
			const reader = new FileReader();
			reader.onload = (e) => {
				const data = new Uint8Array(e.target.result);
				const workbook = XLSX.read(data, { type: "array" });
				const sheetName = workbook.SheetNames[0];
				const sheet = workbook.Sheets[sheetName];
				const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

				const headers = jsonData[0]; // Get the first row as headers
				const isValid = expectedHeaders.every((header) => headers.includes(header));

				if (isValid) {
					// Remove the header row and keep the data rows
					const rows = jsonData.slice(1).map((row, rowIndex) =>
						headers.reduce(
							(obj, header, index) => {
								obj[header] = row[index] || ""; // Map row data to headers
								return obj;
							},
							{ id: rowIndex + 1 } // Add the id column
						)
					);

					setTableData(rows);
					setIsModalOpen(true);
				} else {
					Swal.fire({
						icon: "error",
						title: "Invalid File Structure",
						text: "The uploaded file does not have the required headers.",
					});
				}
			};
			reader.readAsArrayBuffer(file);
		}
	};

	const handleModalSubmit = async () => {
		setSubmittingProvision(true);
		console.log(tableData);
		try {
			const responseProvision = await customHttp.post("/cus_sites/provisionmachines", { table_data: tableData });
			setSubmittingProvision(false);
			setTableData([]);
			setSelectedFile(null);
			setIsModalOpen(false);
			const results = responseProvision.data.results;
			const successResults = [];
			const errorResults = [];
			const existsResults = [];

			// Categorize results by status
			results.forEach((result) => {
				if (result.status === "inserted") {
					successResults.push(result);
				} else if (result.status === "error") {
					errorResults.push(result);
				} else if (result.status === "exists") {
					existsResults.push(result);
				}
			});

			// Construct the success message
			let successMessage = "";
			if (successResults.length > 0) {
				successMessage += `<b>${successResults.length}</b> machine(s) successfully provisioned`;
			}

			// Construct the error message
			let errorMessage = "";
			if (errorResults.length > 0) {
				errorMessage += `<b>${errorResults.length}</b> machine(s) failed to provision due to errors:<br>`;
				errorResults.forEach((result, index) => {
					errorMessage += `${index + 1}. Machine <b>${result.data?.machine_name || "Unknown"}</b>: ${
						result.message
					}<br>`;
				});
			}

			// Construct the exists message
			let existsMessage = "";
			if (existsResults.length > 0) {
				existsMessage += `<b>${existsResults.length}</b> machine(s) already exist in the system:<br>`;
				existsResults.forEach((result, index) => {
					existsMessage += `${index + 1}. Machine <b>${result.data?.machine_name || "Unknown"}</b>: ${
						result.message
					}<br>`;
				});
			}

			Swal.fire({
				icon: successResults.length > 0 ? "success" : "info",
				title: "Provisioning Results",
				html: `${successMessage}${errorMessage}${existsMessage}`,
			});

			console.log(responseProvision);
		} catch (error) {
			console.log(error);
		}
	};

	const handleModalCancel = () => {
		setTableData([]);
		setSelectedFile(null);
		setIsModalOpen(false);
	};

	const handleNavClick = (index) => {
		setActiveIndex(index);
	};

	const columnsModal = expectedHeaders.map((header) => ({
		field: header,
		headerName: header,
		width: 180,
	}));

	const [collapsed, setCollapsed] = useState(false); // State to manage collapse/expand
	const handleMenuClick = () => setCollapsed(!collapsed);

	const handleDragStart = (e, index) => {
		e.dataTransfer.setData("text/plain", index);
		setIsDragging(true);
	};

	const handleDropOrder = (e, dropIndex) => {
		e.preventDefault();
		const dragIndex = parseInt(e.dataTransfer.getData("text/plain"), 10);
		setIsDragging(false);

		if (dragIndex !== dropIndex) {
			const updatedFiles = [...files];
			const [draggedFile] = updatedFiles.splice(dragIndex, 1);
			updatedFiles.splice(dropIndex, 0, draggedFile);
			setFiles(updatedFiles);
		}
	};

	return (
		<>
			{!loading ? (
				<Box display="flex" flexDirection="column" width={"100%"} height={"max-content"} minHeight={"90vh"}>
					<PageTitle title={"Admin"} />
					<Box
						display="flex"
						flexDirection="row"
						width="100%"
						height="100%"
						minHeight={"90vh"}
						justifyContent="flex-start"
						alignItems="flex-start"
						padding={4}>
						<Box width={collapsed ? "60px" : "250px"} height="100%">
							<Box
								display="flex"
								flexDirection="row"
								justifyContent={collapsed ? "center" : "flex-start"}
								width="100%"
								paddingLeft={collapsed ? "0" : "7px"}>
								<IconButton
									onClick={handleMenuClick}
									sx={{ color: (theme) => theme.palette.primary.main }}>
									<MenuIcon />
								</IconButton>
							</Box>

							<List component="nav" aria-labelledby="nested-list-subheader">
								{navItems.map((section, sectionIndex) => {
									const visibleItems = section.items.filter(
										(item) =>
											item.view !== "SuperAdmin" ||
											(user.user_role === "Admin" && user.user_id === 1)
									);

									if (visibleItems.length === 0) return null; // Hide section if no items are visible

									return (
										<React.Fragment key={section.header}>
											{sectionIndex !== 0 && (
												<Divider variant="middle" sx={{ margin: "10px 5px" }} />
											)}
											{!collapsed && (
												<ListSubheader
													sx={{
														backgroundColor: "transparent",
														paddingTop: 0,
														marginTop: 0,
														fontWeight: "bold",
													}}
													component="div">
													{section.header}
												</ListSubheader>
											)}
											{visibleItems.map((item) => (
												<Tooltip title={item.text} key={item.text}>
													<ListItemButton
														selected={activeIndex === item.text}
														onClick={() => handleNavClick(item.text)}>
														<ListItemIcon
															sx={{
																color:
																	activeIndex === item.text
																		? (theme) => theme.palette.primary.main
																		: "#000",
															}}>
															{item.icon}
														</ListItemIcon>
														{!collapsed && (
															<ListItemText
																sx={{
																	color:
																		activeIndex === item.text
																			? (theme) => theme.palette.primary.main
																			: "#000",
																}}
																primary={item.text}
															/>
														)}
													</ListItemButton>
												</Tooltip>
											))}
										</React.Fragment>
									);
								})}
							</List>
						</Box>
						<Divider flexItem orientation="vertical" sx={{ margin: "0 10px" }} />
						<Box sx={{ flex: 1, width: "auto" }}>
							{activeIndex === "Users" && currentUser.user_role === "Admin" && (
								<div className="manage-users-section">
									<Typography variant="h6">Manage Users</Typography>
									<Typography variant="body1">Admin can add, edit, or remove users here.</Typography>
									<div className="users-section">
										<Datagrid
											key={allUsersKey}
											data={allUsers.filter((user) => user.user_id !== 1)}
											columns={columns}
											onSelect={handleRowSelect}
											customButtons={customButtons}
											checkboxSelection={true}
											pageSize={5}
											rowIdField="user_id"
											sortBy={[{ field: "user_status", sort: "asc" }]}
										/>
									</div>
									{selectedUser && (
										<EditUserForm
											allCustomers={allCustomers}
											allSites={allSites}
											selectedUser={selectedUser}
											setSelectedUser={setSelectedUser}
											allUsers={allUsers}
											setAllUsers={setAllUsers}
											assignedSitesLoc={assignedSitesLoc}
											setAssignedSitesLoc={setAssignedSitesLoc}
										/>
									)}
									{createNewUser && (
										<NewUserForm
											allCustomers={allCustomers}
											allSites={allSites}
											newUser={newUser}
											setNewUser={setNewUser}
											allUsers={allUsers}
											setAllUsers={setAllUsers}
											assignedSitesLoc={assignedSitesLoc}
											setAssignedSitesLoc={setAssignedSitesLoc}
											setCreateNewUser={setCreateNewUser}
										/>
									)}
								</div>
							)}
							{activeIndex === "Sites" && currentUser.user_role === "Admin" && (
								<div className="manage-sites-section">
									<Typography variant="h6">Manage Sites</Typography>
									<Typography variant="body1">Admin can add, edit, or remove sites here.</Typography>
									<ManageSites />
								</div>
							)}
							{activeIndex === "Documents" && currentUser.user_role === "Admin" && (
								<div className="manage-sites-section">
									<Typography variant="h6">Manage Documents</Typography>
									<Typography variant="body1">Admin can add, or remove documents here.</Typography>
									<ManageDocuments />
								</div>
							)}
							{activeIndex === "Machine Provision" && currentUser.user_role === "Admin" && (
								<div className="manage-sites-section">
									<Box display="flex" flexDirection="row" width="100%" justifyContent="space-between">
										<Box display="flex" flexDirection="column" alignItems="flex-start">
											<Typography variant="h6">Manage Machine Provisions</Typography>
											<Typography variant="body1">
												Admin can manage the machine provisions to the site.
											</Typography>
										</Box>
										<Box display="flex" flexDirection="row" alignItems="center" columnGap="10px">
											<Button
												variant="contained"
												component="label"
												startIcon={<CloudUploadIcon />}>
												Upload Bulk
												<input
													type="file"
													hidden
													onChange={handleFileChange}
													accept=".csv, .xlsx" // Adjust file types as needed
												/>
											</Button>
											<Box>
												<Typography variant="body1">Upload Bulk Provisions</Typography>
												<Typography variant="body1">
													Download{" "}
													<Link
														href={`${process.env.REACT_APP_SERVER_BASE_URL_HTTP}/templates/ProvisionTemplate.xlsx`}
														variant="body1"
														color="primary"
														underline="hover">
														Provision Template
													</Link>{" "}
													for reference
												</Typography>
											</Box>
										</Box>
									</Box>
									<ManageSiteMachines />
									{/* Modal for displaying table summary */}
									<Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
										<Box
											sx={{
												position: "absolute",
												top: "50%",
												left: "50%",
												transform: "translate(-50%, -50%)",
												width: "fit-content",
												bgcolor: "background.paper",
												boxShadow: 24,
												p: 4,
											}}>
											<Typography variant="h6" gutterBottom>
												File Summary
												<span
													style={{
														color: "#aaa",
														fontStyle: "italic",
														fontSize: "12px",
													}}>
													- {selectedFile && selectedFile.name}
												</span>
											</Typography>
											<DataGrid
												rows={tableData}
												columns={columnsModal}
												initialState={{
													pagination: {
														paginationModel: {
															pageSize: 5,
														},
													},
												}}
												pageSizeOptions={[5]}
												disableSelectionOnClick
												sx={{
													height: 370,
													mb: 2,
													mt: 2,
												}}
											/>
											<Box
												display="flex"
												columnGap="15px"
												alignItems="center"
												flexDirection="row"
												justifyContent="flex-end"
												sx={{ mt: 2 }}>
												<Button variant="outlined" color="primary" onClick={handleModalCancel}>
													Cancel
												</Button>
												<Button variant="contained" color="primary" onClick={handleModalSubmit}>
													{submittingProvision ? (
														<>
															<CircularProgress
																size={16}
																sx={{ color: "white", marginRight: 1 }}
															/>{" "}
															Saving..
														</>
													) : (
														"Submit Provisions"
													)}
												</Button>
											</Box>
										</Box>
									</Modal>
								</div>
							)}
							{activeIndex === "Upload Models" && currentUser.user_role === "Admin" && (
								<div className="manage-sites-section">
									<ModelUpload
										open={true}
										allMachines={allMachines}
										uploadModelColumns={uploadModelColumns}
										uploadModelButtons={uploadModelButtons}
										fetchMachines={fetchMachines}
										newModel={newModel}
										onClose={handleCloseModal}
										setNewModel={setNewModel}
									/>
								</div>
							)}
							{activeIndex === "Scheduler" && (
								<div className="manage-sites-section">
									<Typography variant="h6" gutterBottom>
										Manage Cron Jobs
									</Typography>
									<Typography variant="body1">
										Admins can manage all the cron jobs and schedule new jobs.
									</Typography>
									<div>
										<ManageCronJobs />
									</div>
								</div>
							)}
							{activeIndex === "All Customers" &&
								currentUser.user_role === "Admin" &&
								currentUser.user_id === 1 && (
									<div className="manage-sites-section">
										<Typography variant="h6" gutterBottom>
											Manage All Customers
										</Typography>
										<Typography variant="body1">
											Admins can Create/Edit/Delete records from Customer Master.
										</Typography>
										<div>
											<ManageCustomersMaster />
										</div>
									</div>
								)}
							{activeIndex === "All Sites" &&
								currentUser.user_role === "Admin" &&
								currentUser.user_id === 1 && (
									<div className="manage-sites-section">
										<Typography variant="h6" gutterBottom>
											Manage All Sites
										</Typography>
										<Typography variant="body1">
											Admins can Create/Edit/Delete records from Sites Master.
										</Typography>
										<div>
											<ManageSitesMaster />
										</div>
									</div>
								)}
							{activeIndex === "All Machines" &&
								currentUser.user_role === "Admin" &&
								currentUser.user_id === 1 && (
									<div className="manage-sites-section">
										<Typography variant="h6" gutterBottom>
											Manage All Machines
										</Typography>
										<Typography variant="body1">
											Admins can Create/Edit/Delete records from Machines Master.
										</Typography>
										<div>
											<ManageMachinesMaster />
										</div>
									</div>
								)}
							{activeIndex === "All Products" &&
								currentUser.user_role === "Admin" &&
								currentUser.user_id === 1 && (
									<div className="manage-sites-section">
										<Typography variant="h6" gutterBottom>
											Manage All Products
										</Typography>
										<Typography variant="body1">
											Admins can Create/Edit/Delete records from Products Master.
										</Typography>
										<div>
											<ManageProductsMaster />
										</div>
									</div>
								)}
							{activeIndex === "App Defaults" && currentUser.user_role === "Admin" && (
								<div className="manage-sites-section">
									<Typography variant="h6">App Defaults</Typography>
									<Typography variant="body1">Manage All the Application Default values</Typography>
									<div>
										<DefaultValues />
									</div>
								</div>
							)}
							{activeIndex === "Company Information" && currentUser.user_role === "Admin" && (
								<div className="manage-sites-section">
									<Typography variant="h6">Company Information</Typography>
									<Typography variant="body1">Manage All the Company information </Typography>
									<div>
										<DefaultValues />
									</div>
								</div>
							)}
							{activeIndex === "Theme" && currentUser.user_role === "Admin" && (
								<div className="manage-sites-section">
									<Typography variant="h6">Theme</Typography>
									<Typography variant="body1">Manage Theme of the application</Typography>
									<div>
										<Settings />
									</div>
								</div>
							)}

							{activeIndex === "Change Parts" && currentUser.user_role === "Admin" && (
								<div className="manage-sites-section">
									<Typography variant="h6">Change Parts</Typography>
									<Typography variant="body1">
										Manage the parts and mark them as change parts
									</Typography>
									<div>
										<ManageChangeParts />
									</div>
								</div>
							)}
						</Box>
					</Box>
				</Box>
			) : (
				<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "40vh" }}>
					<CircularProgress />
				</Box>
			)}
		</>
	);
}

export default Admin;